import React from 'react';

// Components
import ClassEventsCard from './ClassEventsCard';

// Hooks
import useCountryName from '../../../../hooks/common/useCountryName';

const ClassEventItem = (props) => {
    const { event, countries, getDynamicEvent, tabsFake } = props;

    const { findCountry } = useCountryName();

    let country = '';
    let countryName = '';

    if (countries !== null)
        if (event?.location?.contry)
            countryName = findCountry(
                countries,
                country,
                event.location.contry
            );

    // RETURN
    return (
        <ClassEventsCard
            tabsFake={tabsFake}
            getDynamicEvent={getDynamicEvent}
            event={event}
            countryName={countryName}
        />
    );
};

export default ClassEventItem;
